import { render, staticRenderFns } from "./AddAttachment.vue?vue&type=template&id=4432cb0d"
import script from "./AddAttachment.vue?vue&type=script&lang=ts"
export * from "./AddAttachment.vue?vue&type=script&lang=ts"
import style0 from "./AddAttachment.vue?vue&type=style&index=0&id=4432cb0d&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports